import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CalendarIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="calendar" ref={ref} {...props}>
      <path d="M18.75,3.34V2a.75.75,0,0,0-1.5,0V3.25h-4.5V2a.75.75,0,0,0-1.5,0V3.25H6.75V2a.75.75,0,0,0-1.5,0V3.35A3.73,3.73,0,0,0,2.32,7V19a3.75,3.75,0,0,0,3.75,3.75H17.94A3.75,3.75,0,0,0,21.69,19V7A3.75,3.75,0,0,0,18.75,3.34ZM20.19,19a2.25,2.25,0,0,1-2.25,2.25H6.07A2.25,2.25,0,0,1,3.82,19V9.72H20.19Zm0-10.78H3.82V7A2.25,2.25,0,0,1,6,4.75H18A2.25,2.25,0,0,1,20.19,7Z" />
    </Icon>
  ),
) as IconWithRender;

CalendarIcon.displayName = 'CalendarIcon';
CalendarIcon.renderIcon = (props) => <CalendarIcon {...props} />;
export default CalendarIcon;
